import React from 'react';

interface SectionHeaderProps {
  title: string;
  description?: string;
  className?: string;
  titleClassName?: string;
  descriptionClassName?: string;
  centered?: boolean;
}

export default function SectionHeader({
  title,
  description,
  className = '',
  titleClassName = '',
  descriptionClassName = '',
  centered = true
}: SectionHeaderProps) {
  return (
    <div className={`${centered ? 'text-center' : ''} mb-16 ${className}`}>
      <h2 className={`font-display text-section-h2 mb-4 text-gradient-neon ${titleClassName}`}>
        {title}
      </h2>
      {description && (
        <p className={`font-sans text-supporting-lg font-medium text-muted-foreground ${centered ? 'max-w-2xl mx-auto' : ''} ${descriptionClassName}`}>
          {description}
        </p>
      )}
    </div>
  );
}

